/* eslint-disable camelcase */
import defaults from "../defaults";

const GET_HOME_PAGE_SHORT = "pages/GET_HOME_SHORT_PAGE";
const GET_HOME_PAGE_SHORT_SUCCESS = "pages/GET_HOME_PAGE_SHORT_SUCCESS";
const GET_HOME_PAGE_SHORT_FAIL = "pages/GET_HOME_PAGE_SHORT_FAIL";

const SET_USER_FOLLOW = "user/SET_USER_FOLLOW";

const initialState = defaults.mainPages;

export default function reducer(state = initialState, action = {}) {
	switch (action.type) {
		// ** GET HOME PAGE SHORT  DATA
		case GET_HOME_PAGE_SHORT:
			return {
				...state,
				home: {
					...state.home,
					loading: true,
					fetched: false,
					fetchedIncluds: false,
				},
			};
		case GET_HOME_PAGE_SHORT_SUCCESS:
			return {
				...state,
				home: {
					...state.home,
					loading: false,
					loaded: true,
					success: true,
					error: false,
					fetchedIncluds: true,
					data: {
						...state.home.data,
						posts:
							action.result?.data?.posts?.response?.posts || [],
						ranking: action.result?.data?.ranking?.response || [],
						notifications:
							action.result?.data?.notifications?.response
								?.notifications || [],
						nearbyOnlinePeople:
							action.result?.data?.online?.response || [],
						nearbyUserLocation:
							action.result?.data?.online?.location || {},
						preferences:
							action.result?.data?.preferences_group?.response ||
							{},
						wantToMeet: action?.result?.data?.meet || null,
						newVideos:
							action.result?.data?.videos?.response?.videos || [],
						newPhotos:
							action.result?.data?.photos?.response?.photos || [],
						hobby:
							action.result?.data?.interests_group?.response ||
							{},
					},
				},
			};
		case GET_HOME_PAGE_SHORT_FAIL:
			return {
				...state,
				home: {
					...state.home,
					loading: false,
					loaded: true,
					success: false,
					error: true,
					fetched: false,
					fetchedIncluds: false,
				},
			};

		case SET_USER_FOLLOW:
			return {
				...state,
				users: {
					...state.users,
					data: state.users?.data?.map((user) => {
						return user?.followers?.user_id ===
							action?.payload?.userId
							? {
									...user,
									followers: {
										...user?.followers,
										is_follow: action.payload?.isFollowed,
									},
							  }
							: user;
					}),
				},
			};

		default:
			return state;
	}
}

export function getHomePageShort({
	searchSex = null,
	media = "any",
	disableCache = false, // ** W celu wyłączenie cache (redis) przekazać 'true'
}) {
	return {
		types: [
			GET_HOME_PAGE_SHORT,
			GET_HOME_PAGE_SHORT_SUCCESS,
			GET_HOME_PAGE_SHORT_FAIL,
		],
		promise: (client) =>
			client.get(`/merge/mainShort`, {
				params: {
					sex: searchSex || "any",
					media,
					disableCache,
				},
				headers: {
					Accept: "application/api.1.3+json",
				},
			}),
	};
}

export const setUserFollow = ({ isFollowed, userId }) => ({
	type: SET_USER_FOLLOW,
	payload: { isFollowed, userId },
});
